export default __webpack_public_path__ + "static/patient-registry-software-development-company-peerbits-531c7fda5c4e6be574e6acec1304b840.png";